const Module = () => import('./HpModule.vue');

const filterPath = (to, from, next) => {
  if (to.fullPath !== to.path) {
    next({ path: to.path });
  } else {
    next();
  }
};

const moduleRoutes = {
  path: '/hp',
  component: Module,
  children: [
      {
          path: 'annualreport/:reportId',
          name: 'annualreport',
          props: true,
          meta: {
              title: 'Health Plan Financial and Statistical Report',
              requiresAuth: true,
              breadcrumb: [
                  { label: 'Annual Reports', route: '/annualreports' },
                  { label: 'Health Plan Financial and Statistical Report' }
              ]
          },
          component: () => import('./views/AnnualReportView.vue'),
          beforeEnter: filterPath
      }
  ]
};

export default router => {
  router.addRoute(moduleRoutes);
};